module.exports = __webpack_public_path__ + "static/media/valenti-tee-promo.77ba350d.jpeg";